// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Component
 */
!(function () {
  var React = require('react');

  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ActionBar = require('share/components/controls/Izenda.ActionBar');
  var ErrorContainer = require('share/components/controls/Izenda.ErrorContainer');
  var SecurityRenderHtmlInReportViewer = require('./Izenda.SecurityRenderHtmlInReportViewer');
  var SecurityRenderHtmlInPrintingExporting = require('./Izenda.SecurityRenderHtmlInPrintingExporting');
  var SecurityConfigTenant = require('./Izenda.SecurityConfigTenant');
  var SecurityRulesList = require('./SecurityRules/Izenda.SecurityRulesList');
  var Alert = require('share/components/controls/Izenda.Alert');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var ScrollBox = require ('share/components/controls/Izenda.ScrollBox');
  var connect = require('share/enhancers/Izenda.Connect');

  var Security = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    loadInitialData: function () {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.getInitial()
        .finally(loader.endLoading.bind(loader));
    },

    componentDidMount: function () {
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      store.init()
        .finally(loader.endLoading.bind(loader));
    },

    onSave: function (e) {
      var props = this.props;
      var loader = props.loader;
      var store = props.store;
      var model = store.model;
      var localization = props.localization;

      model.resetErrorMessage();

      if (model.isDirty) {
        loader.startLoading();

        props.confirmFn('Confirmation', {
          description: localization.getText("COMMON_MESSAGES_CONFIRM_SAVE")
        })
        .then(store.saveTenantSecurity.bind(store))
        .then(store.loadSecurity.bind(store))
        .then(model.readSecuritySetting.bind(model))
        .finally(loader.endLoading.bind(loader));

      } else {
        model.alertMessage = {
          type: 'info',
          message: localization.getText("COMMON_MESSAGES_NO_CHANGES_FOUND")
        };
      }
    },

    onCancel: function () {
      var store = this.props.store;
      var model = store.model;
      var localization = this.props.localization;
      if (model.isDirty) {
        this.props.confirmFn('Confirmation', {
          description: localization.getText("COMMON_MESSAGES_CONFIRM_CHANGES_LOST")
        }).then(this.loadInitialData);
      }
    },

    render: function () {
      var store = this.props.store;
      var loader = this.props.loader;
      var model = store.model;
      return (
        <ScrollBox>
          <div className="izenda-Wrapper">
            <div className="izenda-Wrapper-header">
              <IconMenu />

              <Alert type={model.alertMessage.type}>{model.alertMessage.message}</Alert>
            
              <ActionBar onSave={this.onSave} onCancel={this.onCancel} />

              <ErrorContainer errors={model.errors} />
            </div>

            <div className="izenda-Wrapper-content">

              <div className="u_paddingLeftRight">
                <SecurityConfigTenant store={store} />
                <SecurityRenderHtmlInPrintingExporting store={store} />
                <SecurityRenderHtmlInReportViewer store={store} />
              </div>

              <SecurityRulesList store={store} loaderManager={loader}></SecurityRulesList>
            </div>
          </div>
        </ScrollBox>
      )
    },

    componentWillUnmount: function () {
      this.props.store.destroy();
    }
  });

  module.exports = connect()(Security);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.Security.jsx